import dateFns from 'date-fns'
import AppImg from '../app-img'

import URL from '../../../config.url'


// twitter, instagram
export default
{
    name: 'app-hub-item',

    components:
    {
        AppImg
    },

    props:
    {
        content: { type: Object }
    },

    data()
    {
        return {
            type: 'twitter',
            date: 0,
            img: '',
            author: { href: '#', name: '' },
            text: ''
        }
    },

    created()
    {
        this._initContent(this.content)
    },

    methods:
    {
        _initContent(content)
        {
            this.type = content.type

            switch (this.type)
            {
                case 'twitter':
                
                    this.date = this.getFormatDate(parseInt(content.date, 10))
                    this.img = (content.content && content.content.images && content.content.images.low_resolution) ? content.content.images.low_resolution.url : ''
                    this.author.href = content.author.link
                    this.author.name = content.author.name
                    this.text = content.content.formated_text
                    break

                case 'instagram':

                    this.date = this.getFormatDate(parseInt(content.date, 10))
                    this.img = (content.content && content.content.images && content.content.images.low_resolution) ? content.content.images.low_resolution.url : ''
                    this.author.href = content.author.link
                    this.author.name = content.author.name
                    this.text = content.content.formated_text
                    break

                default:

                    console.error('<app-hub-item> The type ' + this.type + ' of social link don’t exist, use twitter or instagram')
            }
        },

        getFormatDate(timestamp)
        {
            if (timestamp <= 0)
            {
                return ''
            }

            return dateFns.format(timestamp * 1000, 'DD[.]MM[.]YYYY [—] h[:]mm[<sup>]a[</sup>]')
        },

        onLoad()
        {
            this.$emit('load')
        }
    }
}


// WEBPACK FOOTER //
// ./src/scripts/components/app-hub-item/script.js